export default "__VITE_ASSET__Qx4NVeZA__"